module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-us"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (!_vm.loading) ? _c('div', [_c('div', {
    staticClass: "blogheight"
  }), _c('div', {
    staticClass: "innerpage_content_wrap section__blogpage"
  }, [_c('div', {
    staticClass: "container_manual"
  }, [_c('div', {
    staticClass: "page_titlee"
  }, [(_vm.props.title.rendered) ? _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.title.rendered)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page_content"
  }, [_c('div', {
    staticClass: "blog_bar_outer clearfix"
  }, [_c('BlogLists')], 1)])])])]), _c('FooterMain')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12c66078","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/blog/blog.pug
// module id = 613
// module chunks = 1